import clsx from 'clsx'
import { appDay } from 'shared/day'
import { StackIcon } from 'shared/ui'

import type { CampaignStepType, Execution } from '../../types'

import { MessagePreview } from './MessagePreview'
import { TimeSpan } from './Scheduled'
import css from './UpcomingEvents.module.css'

const Label: Partial<Record<CampaignStepType, string>> = {
	EndorseSkill: 'Endorse a skill',
	Follow: 'Follow',
	Message: 'Send the',
	ReactOnPost: 'Like a post',
	ScrapeProfile: 'Scrape',
	VisitProfile: 'Visit'
}

export function InProgressList({
	execution,
	inProgressStepNumber
}: {
	execution: Execution
	inProgressStepNumber: number
}) {
	const isLastStep =
		inProgressStepNumber === execution.step_executions.length - 1

	const index = isLastStep ? inProgressStepNumber : inProgressStepNumber + 1
	const step = execution.step_executions[index]
	const time = execution.step_executions[inProgressStepNumber].expires

	return (
		<ol className={css.list}>
			<WaitingItem time={time} />
			<li className={css.item}>
				{isLastStep ? (
					<>
						<StackIcon
							className={css.icon}
							fill='none'
							icon='stop'
							stack='execution'
							width={16}
						/>
						End of the sequence
					</>
				) : (
					step.type &&
					step.type in Label && (
						<>
							<StepIcon type={step.type} />
							{step.type === 'Message' ? (
								<span className={css.text}>
									{Label[step.type]}{' '}
									<MessagePreview execution={execution.id} step={index} />
								</span>
							) : (
								Label[step.type]
							)}
						</>
					)
				)}
			</li>
		</ol>
	)
}

function StepIcon({ type }: { type: CampaignStepType }) {
	switch (type) {
		case 'EndorseSkill':
			return (
				<StackIcon
					className={css.check}
					icon='check'
					stack='linkedin'
					width={16}
				/>
			)
		case 'Follow':
			return (
				<span className={css.follow}>
					<StackIcon className={css.icon} icon='plus' width={10} />
				</span>
			)
		case 'Message':
			return <StackIcon className={css.icon} icon='message' width={16} />

		case 'ReactOnPost':
			return (
				<StackIcon
					className={css.icon}
					icon='like'
					stack='execution'
					width={16}
				/>
			)

		case 'VisitProfile':
			return (
				<StackIcon
					className={css.icon}
					icon='view'
					stack='execution'
					width={16}
				/>
			)

		default:
			return <StackIcon className={css.icon} icon='message' width={16} />
	}
}

function WaitingItem({ time }: { time?: null | string }) {
	const date = time ? appDay(time) : null

	const isValidDate = Boolean(date && date.isAfter(Date.now()))

	return (
		<li className={clsx(css.item, css.current)}>
			<StackIcon
				className={css.icon}
				icon='clock'
				stack='execution'
				width={16}
			/>
			{isValidDate
				? ['Waiting for a reply', <TimeSpan date={date!} key='t' />]
				: 'Waiting for working hours'}
		</li>
	)
}
